<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import FormPersonDelete from './form-person-delete';

export default {
  name: 'page-program-delete',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  components: {
    FormPersonDelete,
    NuttremaLayoutContent,
  },
  methods: {
    DeletePerson() {},
    onDelete(payload) {
      this.DeletePerson({ id: this.id, type: this.type, payload }).then(() => {
        this.successNotification({ label: 'label.person', message: 'message.default_success_delete_message' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ message: 'message.default_error_delete_message' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/shared/delete/page-person-delete.vue